import SelectCRM from '../ui/select-crm'
import SelectAction from '../ui/select-action'
import selectStyle from '../const/select'
// import amoEventConst from '../const/amo-event'
// import bitrixEventConst from '../const/bitrix24-event'
// import optGetEvent from '../utils/opt_get_event'

const FromSource = ({
  source,
  action,
  optSource,
  optAction,
  callbackSource,
  callbackAction,
}) => {
  // const optEvent = optGetEvent(from, amoEventConst, bitrixEventConst)
  return (
    <div className="create-bundle-form margin-source">
      <div className="create-bundle-form-crm">
        <SelectCRM
          label={'Select a source'}
          value={source}
          callback={callbackSource}
          style={selectStyle}
          opt={optSource}
        />
      </div>
      {source === 'ablefy' && (
        <>
          <div className="create-bundle-form-crm">
            <SelectAction
              label={'Select an action'}
              value={action}
              callback={callbackAction}
              style={selectStyle}
              opt={optAction}
            />
          </div>
          <div className="create-bundle-form-crm">
            <SelectAction
              label={'Select a product'}
              value={action}
              callback={callbackAction}
              style={selectStyle}
              opt={[]}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default FromSource
